import { writable } from 'svelte/store';

export function getDampenLightColor(color: string, limit: number = 240): string {
	// Logic to dampen very light colors (detecting if all channels are > 0xdd)
	const match = color.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
	if (match) {
		const factor = 0.2; // "Débordement léger"

		const r = parseInt(match[1], 16);
		const g = parseInt(match[2], 16);
		const b = parseInt(match[3], 16);

		if (r > limit && g > limit && b > limit) {
			const dampen = (c: number) =>
				Math.round(limit + (c - limit) * factor)
					.toString(16)
					.padStart(2, '0');
			color = `#${dampen(r)}${dampen(g)}${dampen(b)}`;
		}
	}
	return color;
}

export const themeStore = writable<ThemeType>('system'); // 'system', 'dark', 'light'

export type ThemeType = 'system' | 'dark' | 'light';

// Change theme
export function setTheme(newTheme: ThemeType) {
	themeStore.set(newTheme);
	localStorage.setItem('theme', newTheme);
	const isDark =
		newTheme === 'dark' ||
		(newTheme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

	document.documentElement.classList.toggle('dark', isDark);
	document.body.classList.toggle('dark', isDark);
}
